import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { bonuses } from '../data/content';
export function BonusesSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-cobalt/[0.06] px-5 py-6 sm:py-12" data-id="element-53" data-mp="qtt8yusij3by">
      <div className="mx-auto max-w-5xl" data-id="element-54" data-mp="qsi56uz2hvku">
        <div className="mx-auto max-w-2xl text-center" data-id="element-55" data-mp="14t2kvi9orba4">
          <h2 className="font-serif-display text-xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-56" data-mp="14rhqptra9ucs">
            4 ressources complémentaires incluses
          </h2>
          <p className="mt-2 text-sm text-ink/70 sm:mt-3 sm:text-base" data-id="element-57" data-mp="1eicex3o3b40v">
            160 pages qui complètent les cinq volumes : séquences, évaluations, différenciation et
            activités courtes.
          </p>
        </div>

        <div className="mt-6 grid gap-4 sm:mt-10 sm:gap-6 md:grid-cols-2" data-id="element-58" data-mp="1nkbvxvz3u83t">
          {bonuses.map((bonus, i) => {
          const isOpen = openIndex === i;
          return <motion.article key={bonus.badge} initial={{
            opacity: 0,
            y: 15
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.2
          }} transition={{
            duration: 0.3,
            delay: i % 2 * 0.06,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col rounded-2xl border border-cobalt/25 bg-white p-5 shadow-sm shadow-cobalt/5 sm:p-7" data-id="element-59" data-mp="3prwk6rbmlxu8" data-mpi={i}>
                <div className="flex items-center gap-3" data-id="element-60" data-mp="gl58fgdwuxpy">
                  <span className="rounded-md bg-cobalt px-2.5 py-1 text-[11px] font-bold tracking-wide text-white" data-id="element-61" data-mp="gjkdhpnopcrk">
                    {bonus.badge}
                  </span>
                  <span className="text-2xl" aria-hidden="true" data-id="element-62" data-mp="q9vmhqm86c5b">
                    {bonus.icon}
                  </span>
                </div>
                <h3 className="mt-4 text-sm font-bold leading-snug text-ink sm:text-lg" data-id="element-63" data-mp="109e2jvz0lds3">
                  {bonus.title}
                </h3>
                <p className="mt-1 text-[13px] font-medium leading-snug text-cobalt-deep sm:text-sm" data-id="element-64" data-mp="amabq5qteiei">
                  {bonus.subtitle}
                </p>
                <div className="mt-3 flex flex-col items-start gap-1.5" data-id="element-65" data-mp="kb1xtx9728hi">
                  <div className="flex flex-wrap items-center gap-2" data-id="element-66" data-mp="kcd2dzagrk9o">
                    <span className="inline-block rounded-full bg-cobalt/10 px-2.5 py-1 text-[11px] font-medium text-cobalt-deep sm:text-xs" data-id="element-67" data-mp="fjaeo7sdb51e">
                      {bonus.pages}
                    </span>
                    <span className="inline-block rounded-full bg-cobalt px-2.5 py-1 text-[11px] font-bold tracking-wide text-white" data-id="element-68" data-mp="obu9sy9garhh">
                      INCLUS
                    </span>
                  </div>
                  <span className="text-[11px] font-medium text-ink/55 sm:text-xs" data-id="element-69" data-mp="ybctddlg8b90">
                    {bonus.value}
                  </span>
                </div>

                <div className="mt-4 border-t border-cobalt/10 pt-3 sm:hidden" data-id="element-70" data-mp="302y8tnw2hcd3">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between text-xs font-bold text-ink/70" data-id="element-71" data-mp="1fkdzo7pj1f5p">
                    Voir le contenu
                    <ChevronDownIcon className={`h-4 w-4 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-72" data-mp="1asdtvymrzs17" />
                  </button>
                  <AnimatePresence initial={false} data-id="element-73" data-mp="10swmncrvl634">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.25,
                  ease: [0.23, 1, 0.32, 1]
                }} className="overflow-hidden" data-id="element-74" data-mp="mxb49og5dkjo">
                        <p className="pt-3 text-[13px] leading-relaxed text-ink/70" data-id="element-75" data-mp="m51l0j9au55z">
                          {bonus.description}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>

                <p className="mt-4 hidden flex-1 text-sm leading-relaxed text-ink/70 sm:block" data-id="element-76" data-mp="8737fg2sycrj">
                  {bonus.description}
                </p>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}